import { useEffect, useRef } from 'react';

import { useFormikContext } from 'formik';
import { extractErrorPaths, sanitizeElementId } from 'utilities/formUtilities';
import { scrollToElement } from 'utilities/scrollToElement';

const ScrollToError = () => {
  const { isSubmitting, setSubmitting, isValidating, errors } = useFormikContext();
  const wasSubmitting = useRef(false);

  useEffect(() => {
    const isOrWasSubmitting = wasSubmitting.current || isSubmitting;

    if (Object.keys(errors).length && isOrWasSubmitting && !isValidating) {
      const firstErrorId = sanitizeElementId(extractErrorPaths(errors)[0]);
      scrollToElement(firstErrorId);
      setSubmitting(false);
    }
    wasSubmitting.current = isSubmitting;
  }, [errors, isSubmitting, isValidating, setSubmitting]);

  return null;
};

export default ScrollToError;
